import api from '../utils/api';

const BASE = '/api/site-feedback';

/**
 * Submit new site feedback.
 * @route POST /api/site-feedback/create
 * @param {{ sender: string, text: string, sitewide?: boolean }} data
 * @returns {Promise<Object>} Created feedback document (populated)
 */
export const createFeedback = (data) =>
    api.post(`${BASE}/create`, data).then((r) => r.data);

/**
 * Get sitewide feedback submitted by a specific user.
 * @route GET /api/site-feedback/:userId
 * @param {string} userId
 * @returns {Promise<Object[]>} Feedback documents for the user
 */
export const getUserFeedback = (userId) =>
    api.get(`${BASE}/${userId}`).then((r) => r.data);

/**
 * Get all sitewide feedback (admin use).
 * @route GET /api/site-feedback
 * @returns {Promise<Object[]>} All sitewide feedback documents
 */
export const getAllSiteFeedback = () =>
    api.get(`${BASE}/`).then((r) => r.data);

/**
 * Open or close a feedback thread.
 * @route PATCH /api/site-feedback/status/:feedbackId
 * @param {string} feedbackId
 * @param {boolean} status - true to close, false to reopen
 * @returns {Promise<Object>} Updated feedback document
 */
export const setFeedbackStatus = (feedbackId, status) =>
    api.patch(`${BASE}/status/${feedbackId}`, { status }).then((r) => r.data);

/**
 * Delete a site feedback document.
 * @route DELETE /api/site-feedback/delete/:feedbackId
 * @param {string} feedbackId
 * @returns {Promise<{ message: 1, feedback: Object }>}
 */
export const deleteSiteFeedback = (feedbackId) =>
    api.delete(`${BASE}/delete/${feedbackId}`).then((r) => r.data);

/**
 * Append a follow-up message to a feedback thread.
 * @route PATCH /api/site-feedback/add-message/:feedbackId
 * @param {string} feedbackId
 * @param {{ sender: string, text: string }} data
 * @returns {Promise<Object>} Updated feedback document with the new message
 */
export const addMessage = (feedbackId, data) =>
    api.patch(`${BASE}/add-message/${feedbackId}`, data).then((r) => r.data);
